module.exports = __webpack_public_path__ + "static/img/200318.425434b8.png";